import gsap from 'gsap';
import Swiper from 'swiper';
import SwiperCore, { Pagination, Autoplay } from 'swiper/core';

import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.css';


export default class SpKv{

    constructor(){
        SwiperCore.use([Pagination, Autoplay]);
        this._init();
    }


    _init(){
        this.$spkv = document.querySelector('.spkv');
        this._setSwiper();
    }


    _setSwiper(){
        const opts = {
            loop: true,
            slidesPerView: 'auto',
            autoplay: {
                delay: 7000
            },
            pagination: {
                el: ".spkv__pagination",
                clickable: true,
            },
            spaceBetween: 0,
            speed: 700,
            observer: true,
            observeParents: true
        };
    
        this.swiper = new Swiper('.spkv .swiper-container', opts);
        //this.swiper.on('slideChange', this._slideChange.bind(this));

        document.querySelector('.spkv__title').classList.add('-active');
    }

    _slideChange(){
        const $slide = document.querySelector('.swiper-slide-active');
        if($slide.classList.contains('-active')) return;
        $slide.classList.add('-active');
    }
}
